import React from 'react';
import {Container} from 'react-bootstrap';
import './Banner.css'

const Banner = () => {
    return (
    <div>
      <Container>
        <div className=" banner-section">
  <div className="banner-image">
  <img src="https://i.ibb.co/pwqc0w4/Untitled-design-41.png" alt="" />
  </div>
  <div >
  <h3 className="title">The right help <br />
             at the right time.</h3>
  </div>
  </div>
      </Container>
      </div>
    
);
};

export default Banner;